import { Component, OnInit } from '@angular/core';
import { SettingsService, UsuarioService } from '../../services/service.index';
import { Usuario } from '../../models/usuario.model';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  soporte = false;
  // usuario: Usuario;
   checked1: boolean;
   ajustes = {
    temaUrl: 'assets/css/colors/blue.css',
    tema: 'blue'
  };
   usuario = localStorage.getItem('usuario');
   email = localStorage.getItem('emailuser');
   usuariof = '';
   soyfactor = false;
   factorblack = false;
   soybase = false;
   soyventus = false;
   soyfliebentres = false;
   soyfliebencap = false;
   soyfactea = false;
   soyunita = false;
   soyfacturacion = false;
  mostrarMenu = true;
  public subscriber: Subscription;
  constructor( public _usuarioService: UsuarioService,
               public _ajustes: SettingsService,
               private router: Router) {
                this.factorblack = false;
               /* if ( localStorage.getItem('ajustes') ) {
                  this.ajustes = JSON.parse( localStorage.getItem('ajustes') );
                  if ( this.ajustes.tema === 'blue' ) {
                   // console.log('es false');
                    this.checked1 = false;
                  } else if ( this.ajustes.tema === 'blue-dark' ) {
                    this.checked1 = true;

                  }
                } */
                if (localStorage.getItem('quiensoy')) {
                  if (localStorage.getItem('quiensoy') === 'base') {
                    this.ajustes.tema = 'orangebase';
                    this.ajustes.temaUrl = 'assets/css/colors/orangebase.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                  } else if (localStorage.getItem('quiensoy') === 'factor') {
                    this.ajustes.tema = 'blue';
                    this.ajustes.temaUrl = 'assets/css/colors/blue.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                  } else if (localStorage.getItem('quiensoy') === 'factorblack') {
                    this.ajustes.tema = 'blue-dark';
                    this.ajustes.temaUrl = 'assets/css/colors/blue-dark.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.factorblack = true;
                  } else if (localStorage.getItem('quiensoy') === 'ventus') {
                    this.ajustes.tema = 'ventus';
                    this.ajustes.temaUrl = 'assets/css/colors/ventus.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.soyventus = true;
                  } else if (localStorage.getItem('quiensoy') === 'fliebentres') {
                    this.ajustes.tema = 'fliebentres';
                    this.ajustes.temaUrl = 'assets/css/colors/fliebentres.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.soyfliebentres = true;
                  } else if (localStorage.getItem('quiensoy') === 'fliebencap') {
                    this.ajustes.tema = 'fliebencap';
                    this.ajustes.temaUrl = 'assets/css/colors/fliebencap.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.soyfliebencap = true;
                  } else if (localStorage.getItem('quiensoy') === 'factea') {
                    this.ajustes.tema = 'factea';
                    this.ajustes.temaUrl = 'assets/css/colors/factea.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.soyfactea = true;
                  } else if (localStorage.getItem('quiensoy') === 'unita') {
                    this.ajustes.tema = 'unita';
                    this.ajustes.temaUrl = 'assets/css/colors/unita.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.soyunita = true;
                  } else if (localStorage.getItem('quiensoy') === 'facturacion') {
                    this.ajustes.tema = 'facturacion';
                    this.ajustes.temaUrl = 'assets/css/colors/facturacion.css';
                    this._ajustes.aplicarTema( this.ajustes.tema );
                    this.soyfacturacion = true;
                  }
                } 
               }

  ngOnInit() {
    let options = JSON.parse(localStorage.getItem('dataacc'));
    if ( options.includes(btoa('/soporte')) ) {
      this.soporte = true;
    } else {
      this.soporte = false;
    }
  this.soyfactor = false;
  this.soybase = false;
  this.soyventus = false;
  this.soyfactea = false;
  this.soyfliebentres = false;
  this.soyfliebencap = false;
  this.soyunita = false;
  this.soyfacturacion = false;
  let quiensoy = localStorage.getItem('quiensoy' );

    this.subscriber = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if(event['url'] == '/usuariosproveedores/afiliacion' || this.router.url == '/usuariosproveedores/afiliacion'){
        this.mostrarMenu = false;
      }else{
        this.mostrarMenu = true;
      }
    });

  switch (quiensoy) {
    case 'factor':
      this.soyfactor = true;
      break;
    case 'base':
      this.soybase = true;
      break;
    case 'ventus':
      this.soyventus = true;
      break;
    case 'fliebentres':
      this.soyfliebentres = true;
      break;
    case 'fliebencap':
      this.soyfliebencap = true;
      break;
    case 'factea':
      this.soyfactea = true;
      break;
    case 'unita':
      this.soyunita = true;
      break;
    case 'facturacion':
      this.soyfacturacion = true;
      break;
    default:
      this.soyfactor = true;
      break;
  }
  this.usuariof = this.usuario.slice(1, -1);
  let  email = this.email;
  }

  cambiarColor( tema: string) {  // , link: any ) {

    this.checked1 = !this.checked1;
    if (this.checked1) {
      tema = 'blue';
      this.checked1 = false;
    } else {
      tema = 'blue-dark';
      this.checked1 = true;
    }
    this._ajustes.aplicarTema( tema );

  }

}
